var __jsx = React.createElement;
import React from "react";
import { Link } from "react-router-dom";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var ResponsivePostGrid = function ResponsivePostGrid(_ref) {
  var posts = _ref.posts,
    ctaLink = _ref.ctaLink,
    _ref$sectionType = _ref.sectionType,
    sectionType = _ref$sectionType === void 0 ? "marketing_carousel1" : _ref$sectionType,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? "home" : _ref$referralLocation,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("ul", {
    className: "flex gap-5 flex-nowrap overflow-auto px-4 snap-x snap-mandatory lg:grid lg:grid-cols-[repeat(auto-fill,minmax(273px,1fr))] lg:gap-5 list-none lg:pb-0 lg:px-0 ".concat(className)
  }, posts.length > 0 && (posts === null || posts === void 0 ? void 0 : posts.map(function (post, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: post.id,
      className: "flex-none snap-center min-h-full lg:w-full w-[300px]"
    }, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      titleTag: "h3",
      rank: i + 1,
      sectionType: sectionType,
      referralLocation: referralLocation,
      page: page
    }));
  })), posts.length >= 4 && /*#__PURE__*/React.createElement("li", {
    className: "flex items-center justify-center rounded bg-[#3C56D4] shadow-md w-[165px] flex-none snap-center p-6 gap-1 md:hidden"
  }, /*#__PURE__*/React.createElement(Link, {
    to: ctaLink,
    className: "h-full flex items-center justify-center w-[165px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-white text-right text-base font-bold leading-6"
  }, t("إعرض المزيد من السيارات", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    className: "text-white text-right text-base font-bold leading-6 en:transform en:rotate-180",
    src: CDN_LINK + "/assets/images/arrow-left-white.svg",
    alt: "arrow-left-white"
  })))));
};
export default ResponsivePostGrid;